import { render, staticRenderFns } from "./FreteRapidoComponent.vue?vue&type=template&id=19b93e04"
import script from "./FreteRapidoComponent.vue?vue&type=script&lang=js"
export * from "./FreteRapidoComponent.vue?vue&type=script&lang=js"
import style0 from "./FreteRapidoComponent.vue?vue&type=style&index=0&id=19b93e04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports